export default __webpack_public_path__ + "static/media/detail_main_img_5.ec827aee.png";